export default {
  sessions: {
    zh_cn: '订单数量',
    zhhant: '訂單數量',
    en: 'User Sessions',
    he: 'מפגשי משתמשים',
    de: 'Benutzersitzungen',
    es: 'Sesiones de Usuario',
    ru: 'Сессии пользователей',
    vi: 'Phiên người dùng',
  },
  energy: {
    zh_cn: '充电电量',
    zhhant: '充電電量',
    en: 'Energy Used',
    he: 'אנרגיה שנעשה בה שימוש',
    de: 'Verbrauchte Energie',
    es: 'Energía Usada',
    ru: 'Использованная энергия',
    vi: 'Năng lượng sử dụng',
  },
  fees: {
    zh_cn: '充电费用',
    zhhant: '充電費用',
    en: 'Fees Collected',
    he: 'דמי טעינה',
    de: 'Erhobene Gebühren',
    es: 'Tarifas Recaudadas',
    ru: 'Собранные сборы',
    vi: 'Phí thu được',
  },
  viewCharger: {
    zh_cn: '查看设备列表',
    zhhant: '查看設備列表',
    en: 'View Chargers',
    he: 'צפה במטענים',
    de: 'Ladegeräte anzeigen',
    es: 'Ver Cargadores',
    ru: 'Просмотреть зарядные устройства',
    vi: 'Xem bộ sạc',
  },
  last24Hour: {
    zh_cn: '过去 24 小时',
    zhhant: '過去 24 小時',
    en: 'Last 24 Hour',
    he: '24 השעות האחרונות',
    de: 'Letzte 24 Stunden',
    es: 'Últimas 24 Horas',
    ru: 'Последние 24 часа',
    vi: '24 giờ qua',
  },
  today: {
    zh_cn: '今天',
    zhhant: '今天',
    en: 'Today',
    he: 'היום',
    de: 'Heute',
    es: 'Hoy',
    ru: 'Сегодня',
    vi: 'Hôm nay',
  },
  yesterday: {
    zh_cn: '昨天',
    zhhant: '昨天',
    en: 'Yesterday',
    he: 'אתמול',
    de: 'Gestern',
    es: 'Ayer',
    ru: 'Вчера',
    vi: 'Hôm qua',
  },
  last30Day: {
    zh_cn: '最近 30 天',
    zhhant: '最近 30 天',
    en: 'Last 30 Day',
    he: '30 הימים האחרונים',
    de: 'Letzte 30 Tage',
    es: 'Últimos 30 Días',
    ru: 'Последние 30 дней',
    vi: '30 ngày qua',
  },
  currentMonth: {
    zh_cn: '本月',
    zhhant: '本月',
    en: 'Current Month',
    he: 'חודש נוכחי',
    de: 'Aktueller Monat',
    es: 'Mes Actual',
    ru: 'Текущий месяц',
    vi: 'Tháng hiện tại',
  },
  lastMonth: {
    zh_cn: '上个月',
    zhhant: '上個月',
    en: 'Last Month',
    he: 'חודש שעבר',
    de: 'Letzter Monat',
    es: 'Mes Pasado',
    ru: 'Прошлый месяц',
    vi: 'Tháng trước',
  },
  last12Month: {
    zh_cn: '最近 12 个月',
    zhhant: '最近 12 個月',
    en: 'Last 12 Month',
    he: '12 החודשים האחרונים',
    de: 'Letzte 12 Monate',
    es: 'Últimos 12 Meses',
    ru: 'Последние 12 месяцев',
    vi: '12 tháng qua',
  },
  timeRangeError:{
    zh_cn: '仅允许自定义选择31天的数据',
    zhhant: '只允许自定义选择31天的数据',
    en: 'Only custom selection of 31 days data is allowed',
    he: 'ניתן לבחור בחירה מותאמת רק ל-31 ימים',
    de: 'Nur eine benutzerdefinierte Auswahl von 31 Tagen-Daten ist erlaubt',
    ru: 'Разрешено только выбор 31-дневных данных',
    vi: 'Chỉ cho phép chọn dữ liệu 31 ngày',
  },
  custom:{
    zh_cn: '自定义',
    zhhant: '自定義',
    en: 'Custom',
    he: 'תפריט מותאם אישית',
    de: 'Benutzerdefiniert',
    es: 'Personalizado',
    ru: 'Пользовательский',
    vi: 'Tùy chỉnh',
  },
  currentYear: {
    zh_cn: '今年',
    zhhant: '今年',
    en: 'Current Year',
    he: 'שנה נוכחית',
    de: 'Aktuelles Jahr',
    es: 'Año Actual',
    ru: 'Текущий год',
    vi: 'Năm hiện tại',
  },
  lastYear: {
    zh_cn: '去年',
    zhhant: '去年',
    en: 'Last Year',
    he: 'שנה שעברה',
    de: 'Letztes Jahr',
    es: 'Año Pasado',
    ru: 'Прошлый год',
    vi: 'Năm ngoái',
  },
  allOrderStat: {
    zh_cn: '总充电数据',
    zhhant: '總充電數據',
    en: 'Total Charger Info',
    he: 'מידע על כל המטענים',
    de: 'Gesamte Ladeinformationen',
    es: 'Información Total de Cargadores',
    ru: 'Общая информация о зарядных устройствах',
    vi: 'Thông tin tổng thể về bộ sạc',
  },
  sessionsUnit: {
    zh_cn: '{interval} 内订单总数：{n}',
    zhhant: '{interval} 內訂單總數：{n}',
    en: 'Total User Sessions in {interval}: {n}',
    he: 'סך כל מפגשי המשתמשים ב-{interval}: {n}',
    de: 'Gesamtanzahl der Benutzersitzungen in {interval}: {n}',
    es: 'Total de Sesiones de Usuario en {interval}: {n}',
    ru: 'Общее количество сессий пользователей за {interval}: {n}',
    vi: 'Tổng số phiên người dùng trong {interval}: {n}',
  },
  energyUnit: {
    zh_cn: '{interval} 内电量总数：{n}',
    zhhant: '{interval} 內電量總數：{n}',
    en: 'Total Energy Used in {interval}: {n}',
    he: 'סך כל האנרגיה שנעשה בה שימוש ב-{interval}: {n}',
    de: 'Gesamtenergieverbrauch in {interval}: {n}',
    es: 'Total de Energía Usada en {interval}: {n}',
    ru: 'Общее количество использованной энергии за {interval}: {n}',
    vi: 'Tổng năng lượng sử dụng trong {interval}: {n}',
  },
  feesUnit: {
    zh_cn: '{interval} 内费用总数：{n}',
    zhhant: '{interval} 內費用總數：{n}',
    en: 'Total Fees Collected in {interval}: {n}',
    he: 'סך כל העמלות שנאספו ב-{interval}: {n}',
    de: 'Gesamte Gebühren in {interval}: {n}',
    es: 'Total de Tarifas Recaudadas en {interval}: {n}',
    ru: 'Общее количество собранных сборов за {interval}: {n}',
    vi: 'Tổng phí thu được trong {interval}: {n}',
  },
  offline: {
    zh_cn: '设备离线',
    zhhant: '設備離線',
    en: 'Offline Equipment',
    he: 'ציוד לא מקוון',
    de: 'Offline-Geräte',
    es: 'Equipo Desconectado',
    ru: 'Оборудование офлайн',
    vi: 'Thiết bị ngoại tuyến',
  },
  abnormal: {
    zh_cn: '异常设备',
    zhhant: '異常設備',
    en: 'Abnormal Equipment',
    he: 'ציוד חריג',
    de: 'Abnormale Geräte',
    es: 'Equipo Anómalo',
    ru: 'Аномальное оборудование',
    vi: 'Thiết bị bất thường',
  },
  working: {
    zh_cn: '工作中设备',
    zhhant: '工作中設備',
    en: 'Working Equipment',
    he: 'ציוד פעיל',
    de: 'Arbeitsgeräte',
    es: 'Equipo en Funcionamiento',
    ru: 'Работающее оборудование',
    vi: 'Thiết bị đang hoạt động',
  },
  idle: {
    zh_cn: '空闲设备',
    zhhant: '空閒設備',
    en: 'Idle Equipment',
    he: 'ציוד פנוי',
    de: 'Leerlaufgeräte',
    es: 'Equipo Inactivo',
    ru: 'Бездействующее оборудование',
    vi: 'Thiết bị nhàn rỗi',
  },
  client: {
    zh_cn: '客户端',
    zhhant: '客戶端',
    en: 'Client',
    he: 'לקוח',
    de: 'Kunde',
    es: 'Cliente',
    ru: 'Клиент',
    vi: 'Khách hàng',
  },
  session: {
    zh_cn: '会话',
    zhhant: '會話',
    en: 'Sessions',
    he: 'סשנים',
    de: 'Sitzungen',
    es: 'Sesiones',
    ru: 'Сессии',
    vi: 'Các phiên',
  },
  status: {
    zh_cn: '状态',
    zhhant: '狀態',
    en: 'Status',
    he: 'סטטוס',
    de: 'Status',
    es: 'Estado',
    ru: 'Статус',
    vi: 'Tình trạng',
  },
  connection: {
    zh_cn: '连接',
    zhhant: '連接',
    en: 'Connections',
    he: 'חיבורים',
    de: 'Verbindungen',
    es: 'Conexiones',
    ru: 'Подключения',
    vi: 'Kết nối',
  },
  allConnections: {
    zh_cn: '总连接数',
    zhhant: '總連接數',
    en: 'All Connections',
    he: 'סך כל החיבורים',
    de: 'Alle Verbindungen',
    es: 'Todas las Conexiones',
    ru: 'Все подключения',
    vi: 'Tất cả các kết nối',
  },
  liveConnections: {
    zh_cn: '在线连接数',
    zhhant: '在線連接數',
    en: 'Live Connections',
    he: 'חיבורים פעילים',
    de: 'Aktive Verbindungen',
    es: 'Conexiones Activas',
    ru: 'Активные подключения',
    vi: 'Kết nối trực tuyến',
  },
  allStat: {
    zh_cn: '全部电站',
    zhhant: '全部電站',
    en: 'All Stations',
    he: 'כל התחנות',
    de: 'Alle Stationen',
    es: 'Todas las Estaciones',
    ru: 'Все станции',
    vi: 'Tất cả các trạm',
  },
  allOperator: {
    zh_cn: '全部运营商',
    zhhant: '全部營運商',
    en: 'All Operators',
    he: 'כל הפעילים',
    de: 'Alle Operatoren',
    es: 'Todos los Operadores',
    ru: 'Все операторы',
    vi: 'Tất cả các nhà cung cấp',
  },
  statData: {
    zh_cn: '充电数据',
    zhhant: '充電數據',
    en: 'Charger Data',
    he: 'מידע על המטענים',
    de: 'Ladeinformationen',
    es: 'Información de Cargadores',
    ru: 'Информация о зарядных устройствах',
    vi: 'Thông tin về bộ sạc',
  },
  statDataDesc: {
    zh_cn: '充电数据为当前时段的所有已结算充电数据总和',
    zhhant: '充電數據為當前時段的所有已结算充電數據總和',
    en: 'Charger Data is the sum of all settled charger data in the current time period',
    he: 'מידע על המטענים הוא סכום של כל המידע שצוין על המטענים во הזמן הנוכחי',
    de: 'Ladeinformationen ist die Summe aller abgerechneten Ladeinformationen im aktuellen Zeitraum',
    es: 'Información de Cargadores es la suma de todos los datos de cargadores que se han establecido en el período de tiempo actual',
    ru: 'Информация о зарядных устройствах - это сумма всех данных о зарядных устройствах, зарегистрированных в текущем временном интервале',
    vi: 'Thông tin về bộ sạc - là tổng của tất cả thông tin về bộ sạc đã đăng ký trong khoảng thời gian hiện tại',
  },
  toDo: {
    zh_cn: '待办事项',
    zhhant: '待辦事項',
    en: 'To Do',
    he: 'לעשות',
    de: 'Zu tun',
    es: 'Por hacer',
    ru: 'Что нужно сделать',
    vi: 'Cần làm gì',
  },
  checkAll: {
    zh_cn: '查看全部',
    zhhant: '查看全部',
    en: 'View All',
    he: 'צפה בכול',
    de: 'Alle anzeigen',
    es: 'Ver todo',
    ru: 'Просмотреть все',
    vi: 'Xem tất cả',
  },
  onlineStatus: {
    zh_cn: '实时状态',
    zhhant: '即時狀態',
    en: 'Online Status',
    he: 'סטטוס בזמן אמת',
    de: 'Online-Status',
    es: 'Estado en línea',
    ru: 'Онлайн-статус',
    vi: 'Trạng thái trực tuyến',
  },
  commFeature: {
    zh_cn: '常用功能',
    zhhant: '常用功能',
    en: 'Common Features',
    he: 'תכונות נפוצות',
    de: 'Gemeinsame Funktionen',
    es: 'Características Comunes',
    ru: 'Общие функции',
    vi: 'Các tính năng phổ biến',
  },
  stationOperationData: {
    zh_cn: '场站经营数据',
    zhhant: '场站營運數據',
    en: 'Station Operation Data',
    he: 'מידע עבור תחנות',
    de: 'Daten zur Betriebsführung der Station',
    es: 'Datos de operación de la estación',
    ru: 'Данные о работе станции',
    vi: 'Dữ liệu về hoạt động của trạm',
  },
  chargerTimes: {
    zh_cn: '充电次数',
    zhhant: '總充電數據',
    en: 'Charger Times',
    he: 'מספר פעמים שמונח',
    de: 'Anzahl der Ladungen',
    es: 'Veces de carga',
    ru: 'Число разрядов',
    vi: 'Số lần nạp',
  },
  chargerCapacity: {
    zh_cn: '充电电量(度)',
    zhhant: '充電電量(度)',
    en: 'Charger Capacity',
    he: 'גודל המטען (קליטרים)',
    de: 'Ladekapazität',
    es: 'Capacidad de carga',
    ru: 'Емкость зарядного устройства',
    vi: 'Năng lượng nạp (kWh)',
  },
  chargerTimesSingle: {
    zh_cn: '充电次数(单)',
    zhhant: '總充電數據(單)',
    en: 'Charger Times(Single)',
    he: 'מספר פעמים שמונח(קליטרים)',
    de: 'Anzahl der Ladungen(Single)',
    es: 'Veces de carga(Single)',
    ru: 'Число разрядов(Single)',
    vi: 'Số lần nạp(Single)',
  },
  orderReceivableAmount: {
    zh_cn: '订单应收金额(元)',
    zhhant: '訂單应收金額(元)',
    en: 'Order Receivable Amount',
    he: 'סכום להקבלה(שקלים)',
    de: 'Rechnungsbetrag',
    es: 'Monto a recibir',
    ru: 'Сумма к оплате',
    vi: 'Số tiền phải trả (VND)',
  },
  orderReceivableElectricity: {
    zh_cn: '订单应收电费(元)',
    zhhant: '訂單应收電費(元)',
    en: 'Order Receivable Electricity',
    he: 'סכום להקבלה(שקלים)',
    de: 'Rechnungsbetrag',
    es: 'Monto a recibir',
    ru: 'Сумма к оплате',
    vi: 'Số tiền phải trả (VND)',
  },
  orderReceivableServiceFee: {
    zh_cn: '订单应收服务费(元)',
    zhhant: '訂單应收服務費(元)',
    en: 'Order Receivable Service Fee',
    he: 'סכום להקבלה(שקלים)',
    de: 'Rechnungsbetrag',
    es: 'Monto a recibir',
    ru: 'Сумма к оплате',
    vi: 'Số tiền phải trả (VND)',
  },
  todayOrder: {
    zh_cn: '今日订单',
    zhhant: '今日訂單',
    en: 'Today Order',
    he: 'הזמנות היום',
    de: 'Heute Bestellungen',
    es: 'Pedidos de Hoy',
    ru: 'Заказы сегодня',
    vi: 'Đơn hàng hôm nay',
  },
  profitsharing: {
    zh_cn: '清分管理',
    zhhant: '清分管理',
    en: 'Profit Sharing',
    he: 'ניהול חלוקת רווחים',
    de: 'Profit-Sharing',
    es: 'Gestión de la división de beneficios',
    ru: 'Управление распределением доходов',
    vi: 'Quản lý phân chia lợi nhuận',
  },
  powerStatistics: {
    zh_cn: '电站统计',
    zhhant: '電站統計',
    en: 'Power Statistics',
    he: 'סטטיסטיקה',
    de: 'Leistungsstatistik',
    es: 'Estadísticas de potencia',
    ru: 'Статистика мощности',
    vi: 'Thống kê năng lượng',
  },
  powerManagement: {
    zh_cn: '电站管理',
    zhhant: '電站管理',
    en: 'Power Management',
    he: 'ניהול',
    de: 'Leistungsverwaltung',
    es: 'Gestión de potencia',
    ru: 'Управление мощностью',
    vi: 'Quản lý năng lượng',
  },
  marketActivity: {
    zh_cn: '营销活动',
    zhhant: '市場活動',
    en: 'Market Activity',
    he: 'תחרותי',
    de: 'Marktaktivität',
    es: 'Actividad de mercado',
    ru: 'Активность в маркете',
    vi: 'Hoạt động thị trường',
  },
  charging: {
    zh_cn: '充电中',
    zhhant: '充電中',
    en: 'Charging',
    he: 'נטען',
    de: 'Laden',
    es: 'Cargando',
    ru: 'Заряжается',
    vi: 'Đang nạp',
  },

  ide: {
    zh_cn: '空闲中',
    zhhant: '空閒中',
    en: 'Idle',
    he: 'פנוי',
    de: 'Leerlauf',
    es: 'Inactivo',
    ru: 'Не используется',
    vi: 'Nhàn rỗi',
  },
  offlines: {
    zh_cn: '离线中',
    zhhant: '離線中',
    en: 'Offline',
    he: 'מקוון',
    de: 'Offline',
    es: 'Desconectado',
    ru: 'Офлайн',
    vi: 'Ngoại tuyến',
  },
  failure: {
    zh_cn: '故障中',
    zhhant: '故障中',
    en: 'Failure',
    he: 'תקלה',
    de: 'Fehler',
    es: 'Fallo',
    ru: 'Ошибка',
    vi: 'Cơ hội',
  },
  occupied: {
    zh_cn: '占用中',
    zhhant: '占用中',
    en: 'Occupied',
    he: 'מושך',
    de: 'Belegt',
    es: 'Ocupado',
    ru: 'Занят',
    vi: 'Đã sử dụng',
  },
  switchTemplateStyle: {
    zh_cn: '切换模板风格',
    zhhant: '切換樣式樣式',
    en: 'Switch Template Style',
    he: 'החלפת תצורה',
    de: 'Schalter Vorlage Stil',
    es: 'Cambiar Estilo de Plantilla',
    ru: 'Переключить стиль шаблона',
    vi: 'Chuyển đổi kiểu mẫu',
  },

}

